import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./ImageBlock').then(m => ({default: m.ImageBlock})),
)

export const imageBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock,
  dividers: false,
})
